((Drupal) => {
  const body = document.getElementsByTagName("body")[0];
  const header = document.getElementsByTagName("header")[0];
  const headerContainer = document.querySelectorAll(".header--container")[0];
  const main = document.querySelectorAll("header.has-banner ~ main")[0];
  const navbar = header.getElementsByClassName("navbar")[0];
  const navbarBase = navbar.getAttribute("data-navbar-base");
  const navbarSticky = navbar.getAttribute("data-navbar-sticky");
  let headerHeight = header.offsetHeight;
  let oldScroll = 0;

  const resizeComponent = Drupal.debounce(
    () => {
      // Update heights on resize.
      headerHeight = headerContainer.offsetHeight;

      if (typeof main !== "undefined" && main !== undefined) {
        main.style.marginTop = `${-headerHeight}px`;
      }
    },
    0,
    false
  );

  // Set header height variable.
  const toggleClass = (remove, add) => {
    navbar.classList.remove(remove);
    navbar.classList.add(add);
  };

  function stickyHeader(element) {
    const scrollChange = () => {
      const offset = 1;
      const curScroll =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
            ).scrollTop;

      // Only add the scrolling classes when the navbar is closed.
      if (!body.classList.contains("navbar-open")) {
        // Top of the page.
        if (curScroll < headerHeight) {
          element.classList.remove("sticky--scroll-active");
          element.classList.remove("sticky--scroll-out");
          element.classList.add("sticky--scroll-top");
          toggleClass(navbarSticky, navbarBase);

          // Starting to scroll down, but still under the header height.
          if (curScroll > 0 && oldScroll < curScroll) {
            element.classList.remove("sticky--scroll-top");
            element.classList.add("sticky--scroll-active");
            toggleClass(navbarBase, navbarSticky);
          }
        } else {
          // Scrolled/Scrolling down.
          element.classList.add("sticky--scroll-active");
          element.classList.add("sticky--scroll-out");

          // Scrolling up.
          if (oldScroll > curScroll && curScroll >= offset) {
            element.classList.remove("sticky--scroll-out");
            toggleClass(navbarBase, navbarSticky);
          }
        }
        // Reset scroll value.
        oldScroll = curScroll;
      }
    };
    window.addEventListener("load", scrollChange);
    window.addEventListener("scroll", scrollChange);
    window.addEventListener("resize", resizeComponent);
  }

  // Init sticky header.
  stickyHeader(header);
  resizeComponent();
})(Drupal);
